import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { Field } from 'formik';
import { ErrorMessage } from 'formik';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: ${theme.fonts.main};
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const FormSection = styled.div`
  flex: 1.2;
  max-width: 500px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const CampusInfoDesktop = styled.div`
  flex: 1.6;
  min-width: 340px;

  h2 {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    color: #333;
    text-align: center;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

// export const CampusInfoMobile = styled.div`
//   display: none;
//   margin-bottom: 2rem;

//   h2 {
//     font-size: 1.25rem;
//     margin-bottom: 1.5rem;
//     color: #333;
//     text-align: center;
//   }

//   @media (max-width: 768px) {
//     display: block;
//   }
// `;

export const CampusSelector = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  justify-content: center;
`;

export const CampusButton = styled.button`
  padding: 0.5rem 1rem;
  border: 2px solid #3949ab;
  border-radius: 6px;
  background: ${props => props.isActive ? '#3949ab' : '#f5f7fa'};
  color: ${props => props.isActive ? 'white' : '#3949ab'};
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.isActive ? '#2c3e8a' : '#3949ab'};
    color: white;
    transform: translateY(-1px);
  }
`;

export const CampusCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(26, 35, 126, 0.08);
  padding: 1rem 1.2rem;
  margin-bottom: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(26, 35, 126, 0.12);
  }
`;

export const CampusImageContainer = styled.div`
  width: 100%;
  height: 150px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1rem;
  position: relative;
  background: #f8f9fa;
`;

export const CampusImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 6px;
`;

export const ImageLoadingText = styled.div`
  color: #666;
  font-size: 0.9rem;
  text-align: center;
`;

export const ImageErrorText = styled.div`
  color: #999;
  font-size: 0.9rem;
  text-align: center;
`;

export const CampusTextContent = styled.div`
  /* 文本内容容器，用于分离图片和文本 */
`;

export const CampusName = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #263238;
  margin: 0 0 0.5rem 0;
`;

export const CampusAddress = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin: 0;
  line-height: 1.4;
  position: relative;
  
  @media (max-width: 768px) {
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const CampusPhone = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin: 0.5rem 0 0;
`;

export const QRCodeContainer = styled.div`
  margin: 0;
  display: flex;
  justify-content: flex-end;
  
  @media (max-width: 480px) {
    justify-content: center;
    margin-top: 1rem;
  }
`;

export const QRCodeTitle = styled.p`
  font-size: 0.9rem;
  color: #3949ab;
  margin: 0 0 0.5rem 0;
  text-align: center;
  font-weight: 500;
`;

export const QRCodeImage = styled.img`
  width: 120px;
  height: auto;
  object-fit: contain;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  padding: 5px;

  @media (max-width: 768px) {
    width: 120px;
    height: auto;
  }
  
  @media (max-width: 480px) {
    width: 120px;
    height: auto;
  }
`;

export const QRModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const QRModalContent = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
`;

export const QRModalCloseBtn = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #666;
  line-height: 1;

  &:hover {
    color: #333;
  }
`;

export const QRModalImage = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  border-radius: 8px;
`;

export const MapIcon = styled.span`
  margin-left: 0.5rem;
  font-size: 1.1rem;
  
  @media (min-width: 769px) {
    display: none;
  }
`;

export const MapWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(26, 35, 126, 0.08);
  margin-bottom: 1rem;
  position: relative;
`;

export const GoogleMap = styled.div`
  height: 250px;
  width: 100%;
  border-radius: 8px;
`;

export const MapLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
`;

export const MapText = styled.div`
  color: #555;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  line-height: 1.4;
`;

export const ContactEmail = styled.div`
  text-align: center;
  margin-top: 1.5rem;

  a {
    color: #3949ab;
    text-decoration: none;
    font-weight: 600;
    border: 2px solid #3949ab;
    border-radius: 6px;
    padding: 0.5rem 1rem;
    background: #f5f7fa;
    display: inline-block;
    transition: all 0.3s ease;

    &:hover {
      background: #3949ab;
      color: white;
      transform: translateY(-1px);
    }
  }
`;

export const FormContainer = styled.div`
  flex: 1;
`;

export const InfoContainer = styled.div`
  flex: 1;
`;

export const Input = styled(Field)`
  width: 100%;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border: 1px solid ${theme.colors.text};
  border-radius: 4px;
`;

export const Textarea = styled(Field)`
  width: 100%;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border: 1px solid ${theme.colors.text};
  border-radius: 4px;
  min-height: 100px;
`;

export const Button = styled.button`
  background: ${theme.colors.primary};
  color: ${theme.colors.secondary};
  padding: 0.8rem 1.6rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const Error = styled(ErrorMessage)`
  color: red;
  font-size: 0.9rem;
`;

export const CampusInfoMobile = styled.div`
  display: none;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const CampusToggleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #e9ecef;
  }

  h2 {
    font-size: 1.25rem;
    margin: 0;
    color: #333;
  }
`;

export const ToggleIcon = styled.span`
  font-size: 1.2rem;
  color: #3949ab;
  transition: transform 0.3s ease;
  transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const CampusContent = styled.div`
  max-height: ${props => props.isExpanded ? '2000px' : '0'};
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0.5rem;
  
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const InfoColumn = styled.div`
  flex: 1;
`;
